import React, { useEffect, useState } from "react";
import { PaginationShow } from "../../../comman/action/Pagination";
import NotFound from "../../../components/not-found/NotFound";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import { DescriptionModal, ViewMore } from "../../../comman/action/ViewMore";
import { cashConverter } from "../../../components/Form";
import { Link } from "react-router-dom";

const SpentFunds = ({ listing, page }) => {
  const [showModal, setShowModal] = useState(false);
  const [desValue, setDesValue] = useState("");

  const spentFund = [];
  //-----------handle-pagination-----------
  const handleSeeMore = (value) => {
    setShowModal(true);
    setDesValue(value);
  };
  return (
    <>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Resource Name</th>
              <th>Funds Invested</th>
              <th>Username</th>
              <th>Email Address</th>
              <th>Description</th>
            </tr>
          </thead>

          <tbody>
            {listing.length > 0 ? (
              listing.map(({ _id, name, amount, users, resource }, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{++index + (page - 1) * 10}</td>
                      <td>
                        {" "}
                        <Link to={`/resource-management/view/${resource?._id}`}>
                          {" "}
                          {resource?.title || "N/A"}
                        </Link>
                      </td>{" "}
                      <td>{cashConverter(amount) || "N/A"}</td>
                      <td>{users?.userName || "N/A"}</td>
                      <td>{users?.email || "N/A"}</td>
                      <td>
                        <ViewMore
                          value={resource?.description}
                          handleSeeMore={handleSeeMore}
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })
            ) : (
              <NotFound
                cols={10}
                msg="No Spent Funds Found!"
                icon={<MonetizationOnTwoToneIcon style={{ fontSize: 48 }} />}
              />
            )}
          </tbody>
        </table>
      </div>
      {/* -------pagination--------- */}
      {/* <PaginationShow
                total={total}
                activePage={page}
                handlePageChange={handlePageChange}
            /> */}
      {/* -------see-more-modal--------- */}
      <DescriptionModal
        show={showModal}
        close={() => setShowModal(false)}
        value={desValue}
      />
    </>
  );
};

export default SpentFunds;
